<template lang="html">
  <transition name="fade" mode="out-in">
    <div id="offline-tracker" v-if="showOffline">
      <div
        class="tracker-container d-flex align-items-center justify-content-center bg-secondary"
        :class="{'bg-success': online}"
      >
        <transition name="fade" mode="out-in">
          <!-- Offline message -->
          <div class="offline d-flex align-items-center" v-if="!online" key="off">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#ffffff" d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z"/></svg>
            <transition name="fade" mode="out-in">
              <span class="d-inline-block ml-3 text-left" v-if="!reconnecting" key="not-reconnecting">
                You are offline. Some features<br />
                may not work as expected.
              </span>
              <span class="d-inline-block ml-3 text-left" v-else key="reconnecting">
                Trying to reconnect...
              </span>
            </transition>
          </div>

          <!-- Online message -->
          <div class="online d-flex align-items-center" v-else key="on">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#ffffff" d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z"/></svg>
            <span class="d-inline-block ml-3">You are now online</span>
          </div>
        </transition>

        <!-- Actions -->
        <transition name="fade" mode="out-in">
          <div class="offline-actions ml-5" v-if="!online" key="off">
            <transition name="fade" mode="out-in">
              <!-- Retry -->
              <button
                class="btn btn-link text-uppercase font-weight-bold text-light btn-sm"
                v-if="!reconnecting"
                @click="tryReconnect()"
              >
                Retry
              </button>

              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#ffffff" d="M460.115 373.846l-6.941-4.008c-5.546-3.202-7.564-10.177-4.661-15.886 32.971-64.838 31.167-142.731-5.415-205.954-36.504-63.356-103.118-103.876-175.8-107.701C260.952 39.963 256 34.676 256 28.321v-8.012c0-6.904 5.808-12.337 12.703-11.982 83.552 4.306 160.157 50.861 202.106 123.67 42.069 72.703 44.083 162.322 6.034 236.838-3.14 6.149-10.75 8.462-16.728 5.011z"/></svg>
            </transition>
          </div>

          <div class="online-actions ml-5" v-else key="on">
            <!-- Dismiss -->
            <button
              class="btn btn-link text-uppercase font-weight-bold text-light btn-sm"
              @click="showOffline = false"
            >
              Dismiss
            </button>
          </div>
        </transition>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'offline-tracker',
  data() {
    return {
      online: (navigator) ? navigator.onLine : true,
      reconnecting: false,
      showOffline: false,
      onlineTimeout: null
    };
  },
  methods: {
    downloadOfflineIcons() {
      const icons = ['exclamation-circle', 'check-circle', 'spinner-third'];
      icons.forEach((icon) => {
        const img = new Image();
        img.src = `//${window.location.host}/static/img/${icon}.svg`;
      });
    },
    minimizeLayout() {
      this.minimize = true;
    },
    tryReconnect() {
      this.reconnecting = true;
      setTimeout(this.updateOnline, 2000);
    },
    updateOnline() {
      if (this.onlineTimeout) {
        clearTimeout(this.onlineTimeout);
      }
      this.reconnecting = false;
      this.online = (navigator) ? navigator.onLine : true;
      if (this.online) {
        this.onlineTimeout = setTimeout(() => {
          this.showOffline = false;
          this.onlineTimeout = null;
        }, 5000, this);
      } else {
        this.showOffline = true;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('online', this.updateOnline);
    window.removeEventListener('offline', this.updateOnline);
  },
  created() {
    window.addEventListener('online', this.updateOnline);
    window.addEventListener('offline', this.updateOnline);
    this.downloadOfflineIcons();
  }
};
</script>

<style lang="scss">
#offline-tracker {
  position: fixed;
  bottom: 2%;
  right: 1%;
  top: auto;
  left: auto;
  color: #ffffff;
  font-family: sans-serif;

  .tracker-container {
    padding: 1rem 1.5rem;
    border-radius: 5px;
    opacity: 0.8;
  }

  svg {
    width: 1.25rem;
    height: 1.25rem;
  }

  .offline-actions svg {
    animation: spin 1s linear infinite;
  }

  .btn.btn-sm {
    text-decoration: none !important;
  }

  @-webkit-keyframes spin {
    from { transform: rotate(0); }
    to { transform: rotate(359deg); }
  }

  @keyframes spin {
    from { transform: rotate(0); }
    to { transform: rotate(359deg); }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OfflineTracker.vue